var map = {
	"./PRISM_4562.jpg": 656,
	"./PRISM_5023.jpg": 657,
	"./PRISM_6500.jpg": 658,
	"./PRISM_6623.jpg": 659,
	"./PRISM_8220.jpg": 660
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 655;